<template>
  <div v-if="isAdmin || checkAccess('statements')">
    <report-list-page
        page-title="Statement"
        page-icon="mdi-cash-multiple"
        :descending="true"
        :headers="headers"
        state-end-point="statement.statements"
        :actions="actions"
        :show-component="showComponent"
        item-key="id"
    />
  </div>
</template>

<script>
import ReportListPage from "../../components/ReportListPage";
import IsAuthenticated from "../../middleware/IsAuthenticated";
export default {
  name: "StatementReport",
  mixins: [IsAuthenticated],
  components: {ReportListPage},
  data() {
    return {
      headers: [
        {
          text: 'Date',
          value: 'orderDate',
          sortable: false
        },
        {
          text: 'Invoice',
          value: 'totalInvoice',
          sortable: false
        },
        {
          text: 'Total Amount',
          value: 'totalInvoiceAmountOfDay',
          sortable: false
        },
        {
          text: 'Unpaid',
          value: 'totalUnpaidInvoice',
          sortable: false
        },
        {
          text: 'Unpaid Amount',
          value: 'totalUnpaidInvoiceOfDay',
          sortable: false
        },
        {
          text: 'Paid Amount',
          align: 'right',
          value: 'totalPaidInvoiceOfDay',
          sortable: false
        },
        {
          text: 'Deleted Amount',
          align: 'right',
          value: 'totalDeletedInvoiceOfDay',
          sortable: false
        },
        {
          text: 'Refund Amount',
          align: 'right',
          value: 'totalRefundInvoiceOfDay',
          sortable: false
        }
      ],
      actions: {
        load: 'loadStatements',
        downloadPDF: 'downloadStatementAsPDF'
      },
      showComponent: {
        isUser: false,
        isStatus: false,
        isMethod: false,
        isEmail: false,
        isSite: false,
        isPDF: true,
        isDate: true
      }
    }
  }
}
</script>

<style scoped>

</style>